const PAGES_APP = {
  HOME: "HOME",
  ATELIERS: "ATELIERS",
  STYLEGUIDE: "STYLEGUIDE",
  MATERIEL: "MATERIEL",
  OUTILS: "OUTILS",
  BLOG: "BLOG",
} as const

const PAGES_ATELIERS = {
  ATELIER_LECTURE_FLASH: "ATELIER_LECTURE_FLASH",
  ATELIER_ENQUETE_NOEL: "ATELIER_ENQUETE_NOEL",
  ATELIER_DETECTIVE_CLUX_HALLOWEEN: "ATELIER_DETECTIVE_CLUX_HALLOWEEN",
} as const

export const PAGES = {
  ...PAGES_APP,
  ...PAGES_ATELIERS,
} as const

export type PageKey = keyof typeof PAGES
